import {BaseCachedService} from './Core/BaseCachedService';

class ActivityFeedFilterService extends BaseCachedService {
    get Url() { return super.Url + "/activityFeedFilters"; }
    get PrimaryKeyProperty() { return "activityFeedFilterId"; }
    get ModelName() { return "Activity Feed Filter"; }
}

export const service = new ActivityFeedFilterService();

